// extracted by mini-css-extract-plugin
export default {"default":"jQ9Uf","default--wait":"RAWOH","default--dark":"i3M7s","default__header":"W0AJk","default__discount":"mISno","default__body":"bqNiV","badge":"solky"};